export default "__VITE_ASSET__9V$tWEdD__"